@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/components/custom-scroll/custom-scroll' as *;

.dropdownContainer {
  width: 480px;
  max-height: 780px;
  display: flex;
  padding-top: 16px;
  flex-direction: column;
  background-color: var(--background-soft);
  @include border-radius-r2;
}

.contentWrapper {
  overflow-y: auto;
  min-height: 0;
  @include custom-scroll-minimal;
}

.skeletonLoaderWrapper {
  height: 90px;
  padding: 0 16px 16px;
}

.skeletonLoader {
  height: 100%;
}

.paginationLoaderWrapper {
  padding: 12px 20px;
}
